﻿export const CLICK = 'click';
export const HOVER = 'hover';